export default "__VITE_ASSET__BnWlH_dO__"